import isEmpty from 'lodash/isEmpty';

import { getRankedStarts } from '../utils';
import RankedStarts from './RankedStarts';

export const Ranking = ({ starts, bet_type }) => {
  const ranked_starts = getRankedStarts(starts);

  if (!isEmpty(ranked_starts)) {
    return <RankedStarts starts={ranked_starts} bet_type={bet_type} />;
  }

  return null;
};

export default Ranking;
